import type { Translator } from '@i18n/i18n.utils';

export enum NavigationItem {
  CAMPAIGNS = 'campaigns',
  CAMPAIGNS_ACTIVE = 'campaignsActive',
  CAMPAIGNS_ARCHIVED = 'campaignsArchive',
  CAMPAIGNS_DRAFT = 'campaignsDraft',
  CAMPAIGNS_MY = 'campaignsMy',
  CAMPAIGNS_BOOKMARK = 'campaignsBookmark',
  CAMPAIGNS_ALL = 'campaignsAll',
  CRM_CONTACTS = 'crmContacts',
  CRM_COMPANIES = 'crmCompanies',
  CRM_BIRTHDAYS = 'crmBirthdays',
  CRM_CUSTOMER = 'crmCustomer',
  QUICKSTART = 'quickstart',
  SHOWROOM = 'showroom',
  BOOKING_NEWCAMPAIGN = 'bookingNewCampaign',
  BOOKING_FORECAST = 'bookingForecast',
  OFFER_MANAGEMENT = 'offerManagement',
  SALES = 'sales',
  MEDIA_PLANNING = 'mediaPlanning',
  ASSETS_LIBRARY = 'assetsLibrary',
  ANALYTICS = 'analytics',
  CLIENT_REPORTING = 'clientReporting',
  ORDERS = 'orders',
  DOCUMENT_MANAGEMENT = 'documentManagement',
}
export const getLocalizedNavigationLabel =
  (t: Translator) => (name: string) => {
    const navItemMap: Record<NavigationItem, string> = {
      campaigns: t('navigation.campaigns'),
      campaignsActive: t('navigation.campaignsActive'),
      campaignsArchive: t('navigation.campaignsArchive'),
      campaignsDraft: t('navigation.campaignsDraft'),
      campaignsMy: t('navigation.campaignsMy'),
      campaignsBookmark: t('navigation.campaignsBookmark'),
      campaignsAll: t('navigation.campaignsAll'),
      quickstart: t('navigation.quickstart'),
      showroom: t('navigation.showroom'),
      bookingForecast: t('navigation.mediaPlanner'),
      bookingNewCampaign: t('navigation.newcampaign'),
      crmCustomer: t('navigation.customer'),
      crmContacts: t('navigation.contacts'),
      crmCompanies: t('navigation.companies'),
      crmBirthdays: t('navigation.birthdays'),
      offerManagement: t('navigation.offerManagement'),
      sales: t('navigation.sales'),
      mediaPlanning: t('navigation.mediaPlanning'),
      assetsLibrary: t('navigation.assetsLibrary'),
      analytics: t('navigation.analytics'),
      clientReporting: t('navigation.clientReporting'),
      orders: t('navigation.orders'),
      documentManagement: t('navigation.documentManagement'),
    };
    const match = navItemMap[name as NavigationItem];
    if (!match) {
      // eslint-disable-next-line no-console
      console.warn(`No translation found for navigation item: ${name}`);
    }
    return match || name;
  };
